export const MetricType = Object.freeze({
  Sum: 'sum',
  Max: 'max',
  Avg: 'avg',
  Bool: 'bool',
  Set: 'set',
  Single: 'single',
})
